<template>
  <div class="case-share-detail">
    <!-- 详情页头部 -->
    <detail-header
      title="动态共享预览"
      icon="icon-fenxiang"
      :iconStyle="iconStyle"
      @back="back"
    ></detail-header>
    <div class="case-share-detail-content">
      <div class="row-class" v-if="dialog.form.status == '2'">
        <div class="part">
          <div
            class="part-content"
            style="float: left;text-align: left;padding-left: 30px; display: flex"
          >
            <span
              class="panel-title"
              style="color: #ff0000;max-width: 80px;flex: 1;"
              >拒绝原因 :
            </span>
            <span class="panel-title-div-text" style="margin-top: 0;flex: 1;"
              >&nbsp;{{ dialog.form.rejectReason }}</span
            >
          </div>
          <div
            class="part-content"
            style="float: right;text-align: right;padding-right: 40px;max-width: 300px"
          >
            <span class="panel-title" style="">拒绝时间 : </span>
            <span class="" style="margin-top: 0;">{{
              dialog.form.lastModTm | datetimeFormat
            }}</span>
          </div>
        </div>
      </div>
      <div class="row-class">
        <div class="panel-title-div-text" style="margin: auto">
          <div style="text-align: center;font-weight: bold;font-size: 20px;">
            <span>{{ dialog.form.title }}</span>
          </div>
        </div>
      </div>
      <div class="row-class">
        <div class="part">
          <div
            class="part-content"
            style="float: left;text-align: left;padding-left: 30px"
          >
            <span class="panel-title">分享时间 : </span>
            <span class="panel-title-div-text"
              >&nbsp;{{ dialog.form.createTm | datetimeFormat }}</span
            >
          </div>
          <div
            class="part-content"
            style="float: right;text-align: right;padding-right: 30px"
          >
            <span class="panel-title" style="">分享人 : </span>
            <span class="" style="margin-top: 0;"
              >&nbsp;{{ dialog.form.createUserNm }}</span
            >
          </div>
        </div>
      </div>
      <hr />

      <div class="row-class">
        <div class="panel-title-div-text panel-atta">
          <div
            class="detail-panel"
            v-if="
              dialog.form.attachIds ? dialog.form.attachIds.length > 0 : false
            "
          >
            <el-card class="box-card" style="">
              <div
                style="height: 29px;border-bottom: 1px solid #d7d0c2;color: #333;padding: 2px 10px;font-size: 12px;background: linear-gradient(to bottom, #fefdfc 1%,#f7f6f5 100%);"
              >
                <h2>
                  <b>附件列表</b>
                  <span style="font-weight: normal;">
                    （<span class="attNum">{{
                      dialog.form.attachIds.length
                    }}</span
                    >个<!--，<a href="javascript:void (0);" id="downLoadAllLink" style="color: #7dc196;text-decoration: none;cursor: pointer;">打包下载</a>-->）
                  </span>
                </h2>
              </div>
              <hr />
              <div style="height: 81px;overflow-y: auto">
                <div
                  class="detail-card-apply"
                  v-for="(item, index) of dialog.form.attachIds"
                  :key="index"
                >
                  <div class="detail-card-top">
                    <span
                      class="attachment-type-icon"
                      :class="item | fileIcon(this_)"
                      :style="item | fileColor(this_)"
                    ></span>
                    <span class="attachment-name">{{
                      item.attachmentName
                        ? item.attachmentName
                        : item.attachmentOriginalName
                    }}</span>
                    <span class="attachment-share-time">{{
                      item.createTm | dateFormat
                    }}</span>
                    <button
                      class="attachment-share-download icon-daoru iconfont"
                      @click="preViewAttachment(item, index)"
                    ></button>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <div class="row-class">
        <div class="panel-title-div-text">
          <div class="detail-context" style="height: 490px;overflow: auto">
            <span v-html="dialog.form.content"></span>
          </div>
        </div>
      </div>
    </div>
    <animation
      :loadingDataVisible="dialog.isLoading"
      :loadingText="loadingText"
    ></animation>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { mapState } from "vuex";
import {
  DIALOG_TYPE_ADD,
  DIALOG_TYPE_VIEW,
  DIALOG_TYPE_UPDATE,
  ATTA_FILE_SUF_LIST,
  ATTA_FILE_SHOW_TYPE,
  ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
  CARD_HEIGHT_TYPE,
  TAB_HEIGHT_TYPE,
  ATTA_FILE_DOWN_TYPE,
  PAGE_SIZE_TYPE,
  ATTA_UPLOAD_COMPONENT_TYPE_STR,
  SINGLE_ATTACHMENT_MAX_SIZE
} from "@/constants/constants";
import animation from "@/components/loading/animation";
import DetailHeader from "@/components/common/DetailHeader";
export default {
  name: "CaseShareDetail",
  components: { animation, DetailHeader },
  data() {
    return {
      caseId: null,
      count: 5,
      this_: this,
      //准备的颜色的数组
      attachmentColors: {
        ppt: "#fd585e",
        doc: "#2a83eb",
        docx: "#2a83eb",
        xls: "#16b881",
        xlsx: "#16b881",
        pdf: "#ff734c"
      },
      fileIconType: {
        ppt: "icon-file-ppt-fill",
        xls: "icon-file-excel-fill",
        xlsx: "icon-file-excel-fill",
        doc: "icon-file-word-fill",
        docx: "icon-file-word-fill",
        pdf: "icon-file-pdf-fill"
      },
      fileDialog: {
        attachmentName: "",
        cd: "001-040",
        showFileList: [],
        fileList: [],
        tableDataList: [],
        acceptAttachmentType: ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
        attaFileSuf: ATTA_FILE_SUF_LIST,
        attaFileType: ATTA_FILE_SHOW_TYPE,
        attaFileDownType: ATTA_FILE_DOWN_TYPE,
        drawerVisible: false,
        fileSaveBtnLoading: false,
        updateFlag: false,
        uploadLoading: false
      },
      attachments: [
        {
          attachmentOriginalName: "xl.xlsx"
        },
        {
          attachmentOriginalName: "xl.ppt"
        },
        {
          attachmentOriginalName: "xl.pdf"
        },
        {
          attachmentOriginalName: "xl.docx"
        },
        {
          attachmentOriginalName: "xl.doc"
        }
      ],

      dialog: {
        isLoading: false,
        form: {
          id: "",
          title: "",
          content: "",
          createUserId: "",
          createUserNm: "",
          createTm: null,
          lastModTm: null,
          //附加列表
          attachIds: [],
          status: null,
          rejectReason: ""
        }
      },
      iconStyle: { "font-size": "30px", color: "rgb(79,161,243)" },
      loadingText: "加载中"
    };
  },
  filters: {
    //设置背景颜色和顶上的颜色
    fileBgColor: function(arg, this_) {
      let type = arg.attachmentOriginalName.substring(
        arg.attachmentOriginalName.lastIndexOf(".") + 1
      );
      return "background-color:" + this_.attachmentColors[type];
    },

    //设置图标的颜色
    fileColor: function(arg, this_) {
      let type = arg.attachmentOriginalName.substring(
        arg.attachmentOriginalName.lastIndexOf(".") + 1
      );
      return "color:" + this_.attachmentColors[type];
    },

    //设置类图标
    fileIcon: function(arg, this_) {
      let type = arg.attachmentOriginalName.substring(
        arg.attachmentOriginalName.lastIndexOf(".") + 1
      );
      return this_.fileIconType[type] + " iconfont";
    }
  },

  mounted() {
    this.caseId = Number(this.$route.query.caseId);
    Object.assign(this.$data.dialog.form, this.$options.data().dialog.form);
    this.queryCaseShareDetail();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },

    queryCaseShareDetail() {
      let _this = this;
      this.dialog.isLoading = true;
      let uri =
        this.isDraft == 1
          ? "/eims-api/user/personal/article/detail"
          : "/eims-api/caseShare/detail";
      http
        .post(window.config.api.baseUrl + uri, {
          token: cookie.getCookie("token"),
          data: {
            postCode: _this.viewPostCode,
            postTpCode: _this.viewPostTpCode,
            status: "0"
          }
        })
        .then(response => {
          let data = response.data.data;
          this.dialog.form.id = data.article.id;
          this.dialog.form.createUserId = data.article.createUserId;
          this.dialog.form.createUserNm = data.article.userName;
          this.dialog.form.createTm = data.article.createTm;
          this.dialog.form.title = data.article.postTitle;
          this.dialog.form.content = data.article.postContent;
          this.dialog.form.attachIds = data.article.attachments;
          this.dialog.form.status = data.article.status;
          this.dialog.form.rejectReason = data.article.rejectReason;
          this.dialog.form.lastModTm = data.article.lastModTm;
        })
        .finally(() => {
          _this.dialog.isLoading = false;
        });
    },
    preViewAttachment(item, index) {
      //准备需要查看的附件的链接,然后显示或者下载附件
      let fullName = item.attachmentOriginalName;
      //如果不是图片的格式的附件,则使用上面这种预览方式
      //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
      //附件已上传的预览
      this.handleView(item);
    },
    handleView(item) {
      if (item.file) {
        let fileType = item.file.name.substring(
          item.file.name.lastIndexOf(".") + 1
        );
        let attaFileTypeElement = this.fileDialog.attaFileType[fileType];
        const elink = document.createElement("a");
        if (!attaFileTypeElement) {
          elink.download = item.file.name;
        }
        elink.style.display = "none";
        elink.target = "_blank";
        // elink.href = URL.createObjectURL(new Blob([item.file.raw],{type:attaFileTypeElement}));
        elink.href = URL.createObjectURL(item.file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        let fileType = item.attachmentOriginalName.substring(
          item.attachmentOriginalName.lastIndexOf(".") + 1
        );
        let attaFileTypeElement = this.fileDialog.attaFileType[fileType];
        const elink = document.createElement("a");
        if (!attaFileTypeElement) {
          http
            .get(
              window.config.api.baseUrl +
                "/eims-api/attachment/findFile?token=" +
                cookie.getCookie("token") +
                "&code=" +
                item.code,
              { responseType: "blob" }
            )
            .then(response => {
              if (response) {
                let attaFileDownTypeElement = this.fileDialog.attaFileDownType[
                  fileType
                ];
                elink.download = item.attachmentName
                  ? item.attachmentName
                  : item.attachmentOriginalName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(
                  new Blob([response.data], { type: attaFileDownTypeElement })
                );
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          elink.style.display = "none";
          elink.target = "_blank";
          elink.href =
            window.config.api.baseUrl +
            "/eims-api/attachment/findFile?token=" +
            cookie.getCookie("token") +
            "&code=" +
            item.code;
          // elink.href = URL.createObjectURL(new Blob([response],{type:attaFileTypeElement}));
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }
      }
    }
  },
  computed: {
    ...mapState({
      viewPostCode: state => state.caseShareModule.viewPostCode,
      isDraft: state => state.caseShareModule.isDraft,
      viewPostTpCode: state => state.caseShareModule.viewPostTpCode
    })
  },
  destroyed() {
    this.$store.dispatch("clearViewPostCode", {});
  }
};
</script>

<style lang="scss" scoped>
.case-share-detail {
  margin: 20px;
  height: calc(100vh - 109px);
  background-color: #fff;
  box-shadow: 1px 2px 5px #ccc;
  &-content {
    display: flex;
    flex-direction: column;
    padding: 10px;
    .row-class {
      margin: 10px 0;
      flex: 1;
      width: 100%;
      .panel-title-div-text {
        margin-top: 3px;
        .detail-context {
          line-height: 30px;
          text-indent: 2em;
          padding: 10px 30px 10px 30px;
          font-size: 18px;
          text-align: justify;
        }
      }
      .panel-atta {
        padding-left: 30px;
        padding-right: 30px;
      }
      .detail-card-apply {
        height: 40px;
        display: inline-block;
        margin: 0px;
        width: 100%;
        padding: 0;
        .detail-card-apply-up {
          border-radius: 20px 0 0 20px;
          position: relative;
          content: "";
          display: inline-block;
          /*继承宽度*/
          width: 15px;
          top: 0;
          height: 38px;
          background-color: rgb(251, 175, 87);
        }

        .detail-card-apply-down:hover {
          transition-duration: 400ms;
          cursor: pointer;
          box-shadow: #b4b5b6 1px 10px 30px;
        }

        .detail-card-apply-down {
          transition-duration: 400ms;
          border: 0;
          top: -63px;
          left: 10px;
          position: relative;
          width: inherit;
          background-color: white;
          box-shadow: #dfe0e2 1px 10px 30px;
          border-radius: 8px;
        }
        .detail-card-top {
          text-align: left;
          /*margin: 20px 0px;*/
          height: 40px;
          padding-left: 20px;
          & > button {
            border: 0;
            background-color: #f6f6f6;
            width: 30px;
            height: 30px;
            border-radius: 30px;
            color: #00a6ef;
          }

          & > button:hover {
            background-color: #e5e4e4;
          }

          & > button:active {
            background-color: #d5d5d5;
          }
          .attachment-type-icon {
            color: #fd585e;
            line-height: 40px;
            font-size: 30px;
          }
          .attachment-name {
            font-size: 18px;
          }
          .attachment-share-time {
            line-height: 30px;
            padding: 0 10px;
            font-size: 16px;
            color: #8c939d;
          }
        }

        .detail-card-inner {
        }

        .detail-card-bottom {
          padding: 15px;
          border-top: 1px silver solid;
          height: 80px;
        }
      }
      .part {
        display: flex;
        .part-content {
          flex: 1;
          .panel-title-div {
            font-family: "Helvetica Neue", Helvetica, "PingFang SC",
              "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
              sans-serif;
            color: #9f9f9f;
            text-align: right;
            min-width: 100px;
            /*width: 25%;*/
            float: left;
          }
          .panel-title {
            font-family: "Helvetica Neue", Helvetica, "PingFang SC",
              "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
              sans-serif;
            color: #9f9f9f;
          }
          .panel-title-row {
            font-family: "Helvetica Neue", Helvetica, "PingFang SC",
              "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
              sans-serif;
            color: #9f9f9f;
            text-align: right;
          }
        }
      }
    }
    hr {
      border-top: none;
      border-left: none;
      border-right: none;
      border-bottom: 1px solid #ddd;
    }
  }
}

/deep/ .el-card__body {
  padding: 0;
}
/deep/ .el-tag {
  width: 100vh;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/article/CaseShareDetail.vue